import { Component, OnInit,  HostListener, Input} from '@angular/core';
import { Subscription} from 'rxjs';
import {  ServiceInfo} from '../models/display/serviceInfo';
import { ActivatedRoute, Router, NavigationEnd} from '@angular/router';
//import { ServiceComponent } from './service/service.component';
import { filter} from 'rxjs/operators';
import { DisplayUserActionService } from "../display-user-action.service"
import {  ThemeServiceService } from '../theme-service.service';
import { PageConfigService } from '../page-config.service';

@Component({
  selector: 'app-offline-service-menu',
  templateUrl: './offline-service-menu.component.html',
  styleUrls: ['./offline-service-menu.component.scss']
})

export class OfflineServiceMenuComponent implements OnInit {

   
   config : any

  seletedService: string;
  public _servicesList: any;

  get servicesList() {
    return this._servicesList;
  }
  
  @Input()
  set servicesList(servicesList) {
    this._servicesList = servicesList;
    // conslog(this._servicesList);
    // conslog(this._servicesList);
  }
  private countdownEndRef: Subscription = null;

  public isMobileDivice;
  public innerWidth: any;

  setDevice() {
    if (this.innerWidth <= 768) {
      this.isMobileDivice = false;
      return;
    }
    this.isMobileDivice = true;
  }

  constructor( private PageConfigService : PageConfigService, private router: Router, private displayUserActionService: DisplayUserActionService, private themeService: ThemeServiceService) {
    // conswarn(this.seletedService);
    router.events.subscribe((val) => {
      this.seletedService = this.router.url;
      if (this.seletedService == "") {
        this.seletedService = '/autopartage'
      }
      // conslog(val instanceof NavigationEnd)
    });

    this.PageConfigService.config.subscribe((x) =>{
      this.config = x
    })

    var tokenString = JSON.parse(localStorage.getItem('token_clem_mobi'))

    if(tokenString === null){
      // this._servicesList

    }else{


    }

    console.log("toke==============================+++++++++++++++++++++++++++nString")
    console.log(tokenString)
    console.log(this.config)
    console.log("toke==============================+++++++++++++++++++++++++++nString")
    this.getSite()
  }


  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.setDevice();
    // conslog(this.router.url);
    this.seletedService = this.router.url;
    if (this.seletedService == "/") {
      this.seletedService = '/autopartage'
    }
    // conswarn(this.seletedService);
    // this.serviceList  = this.displayUserActionService.getOfflineServiceList();







    // this.countdownEndRef = this.displayUserActionService.countdownEnd$.subscribe((value)=>{
    //   this.serviceList  = this.displayUserActionService.getnNewSelected(value);
    //   this.seletedService = value;
    // });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.setDevice();

  }

  toggle(id) {
    // this._servicesList = this.displayUserActionService.getnNewSelected(id);
    // console.log(this._servicesList)
    
  }


  getServices(param){

    if(! param || param?.length === 0){ return }
    if(! this.config?.services || this.config?.services?.length === 0){ return }

   var arr1  = param.filter(element => {
      return this.config.services.includes(element.name)
    });
    return arr1
  }



  clickEvent(service){

    if(service.name === 'trajet' && this.config.href_trajet){

      location.href = this.config.href_trajet
      
    }else{

      this.router.navigate([`${service.routingData}`]);
    }


  }

siteType = 'default';

getSite() {
  const host = location.host;

  switch (host) {

    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      this.siteType = 'mam';
      break;

    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
      this.siteType = 'remi';
      break;

    default:
      this.siteType = 'default';
      break;
  }
}
  


}
